module.exports = __webpack_public_path__ + "static/screen-1e85fe63d0f72635a789da41ae1d13ef.png";